import { useState } from "react";
import { Card, Col, Row, Button } from "react-bootstrap";
import { Product } from "../actions/types";
import ProductButtonsBuy from "./ProductButtonsBuy";
import ProductCarousel from "./ProductCarousel";
import { RootState } from "../reducers";
import { useSelector } from "react-redux";
import ProductTagsTypes from "./ProductTagsTypes";
import { PUBLIC_URL } from "../serviceWorker";

interface Props {
  product: Product;
}

const Products = (props: Props) => {
  const [showButtons, setShowButtons] = useState(false);
  const { product } = props;
  const pathImages = useSelector(
    (state: RootState) => state.shop.pathImages[product.id]
  );
  const style = {
    boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2)",
    color: "#000",
    textDecoration: "none",
  };
  const handleClick = () => setShowButtons(!showButtons);
  const types = product.types.filter(
    (type) =>
      type.name === "DAMA" || type.name === "HOMBRE" || type.name === "UNISEX"
  );
  const tagSale = product.types.filter(
    (type) => type.name === "LIQUIDACIÓN" || type.name.match(/%/g)
  );
  const tagPremium = product.types.filter((type) => type.name === "PREMIUM");

  const discountPercentage = Math.ceil(
    ((Number(product.price_regular) - Number(product.price_wholesale)) /
      Number(product.price_regular)) *
      100
  );

  return (
    <Col className="g-2">
      <Card border="light" style={style}>
        {pathImages?.length > 1 ? (
          <ProductCarousel pathImages={pathImages} />
        ) : (
          <Card.Img src={product.path} />
        )}
        {tagSale[0]?.name && (
          <div
            className="rounded-1"
            style={{
              minWidth: 120,
              height: 35,
              top: 5,
              left: -5,
              backgroundColor: "#d2fb1a",
              position: "absolute",
              padding: 8,
            }}
          >
            <h6
              style={{
                textAlign: "center",
                fontSize: 14,
                color: "#000",
              }}
            >
              {tagSale[0].name}
            </h6>
          </div>
        )}
        {tagPremium[0]?.name && (
          <div
            className="rounded-1"
            style={{
              width: 118,
              height: 35,
              top: 5,
              left: -5,
              backgroundColor: "#d2fb1a",
              position: "absolute",
              paddingTop: 5,
            }}
          >
            <img
              style={{
                width: 33,
                marginLeft: 5,
                marginTop: -12,
                marginRight: 6,
              }}
              alt="PREMIUM"
              src={PUBLIC_URL + "img/user/1/premium.gif"}
            />
            <span
              style={{
                textAlign: "center",
                fontSize: 14,
                color: "#000",
                fontWeight: 500,
              }}
            >
              {tagPremium[0].name}
            </span>
          </div>
        )}
        <Card.Body>
          <Row>
            <Col xs={8}>
              <Card.Title className="fs-6">{product.name}</Card.Title>
              {discountPercentage > 1 && (
                <Card.Text className="small text-decoration-line-through mb-0 fw-lighter text-body-secondary">
                  ${product.price_regular}
                </Card.Text>
              )}
              <Card.Title className="fs-5 d-flex flex-row">
                <span>${product.price_wholesale}</span>
                {discountPercentage > 1 && (
                  <span
                    className="small m-1"
                    style={{ fontSize: "14px", color: "rgb(0, 166, 80)" }}
                  >
                    {discountPercentage}% OFF
                  </span>
                )}
              </Card.Title>
            </Col>
            <Col xs={4}>
              <Button variant="secondary" onClick={handleClick}>
                Ver más
              </Button>
            </Col>
            <Card.Text className="fs-6">
              {product.description}{" "}
              <ProductTagsTypes excludeTypes={["Web"]} types={types} />
            </Card.Text>
            {showButtons && <ProductButtonsBuy productId={product.id} />}
          </Row>
        </Card.Body>
      </Card>
    </Col>
  );
};

export default Products;
